// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"d3a41dd4","536":"e7e02e91","682":"e73aac3b","696":"90ab0960","785":"2e63ddb2","976":"55f1a3e9"}[chunkId] + ".chunk.css";
};